import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../components-new/ui/Modal';
import Input from '../../../../../components-new/form/Input';
import FileUpload from '../../../../../components-new/general/FileUpload';
import SilverButton from '../../../../../components-new/buttons/SilverButton';
import BlueButton from '../../../../../components-new/buttons/BlueButton';
import PersonIcon from '../../../../../assets/icons/PersonIcon';
import Translate from '../../../../../components/Translate';
import config from '../../../../../config';
import {generalModalStyles} from '../../../../../utils/General';
import '../../header/SettingsModal.css';

const EmployeeProfileModal = ({member, onClose, onSave}) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [thumbUrl, setThumbUrl] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setFirstName(member && member.firstName ? member.firstName : '');
        setLastName(member && member.lastName ? member.lastName : '');
        setThumbUrl(member && member.thumbUrl ? member.thumbUrl : '');
        setSaving(false);
    }, [member]);

    if (!member) return null;

    const saveProfile = () => {
        const trimmedFirstName = firstName.trim();
        const trimmedLastName = lastName.trim();
        if (!trimmedFirstName || !trimmedLastName || saving) return;

        setSaving(true);
        Promise.resolve(onSave(member.id, {
            firstName: trimmedFirstName,
            lastName: trimmedLastName,
            language: member.language,
            contactNumber: '',
            thumbUrl,
        }))
            .then(onClose)
            .catch(() => {
                // The parent owns the translated error notification; keeping
                // the modal open lets the employee details be corrected/retried.
            })
            .finally(() => setSaving(false));
    };

    return (
        <Modal
            closeTimeoutMS={config.closeTimeoutMS}
            isOpen
            style={generalModalStyles.menuItemModalStyles}
            onRequestClose={saving ? undefined : onClose}
            onCancel={saving ? undefined : onClose}
            title={<Translate text="editEmployee"/>}
            description={<Translate text="editEmployeeDescription"/>}
            headerIcon={<PersonIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
            headerSeparator
            footerSeparator
            footer={
                <React.Fragment>
                    <SilverButton type="button" width="auto" height="40px" disabled={saving} onClick={onClose}>
                        <Translate text="cancel"/>
                    </SilverButton>
                    <BlueButton type="button" width="auto" height="40px" loading={saving}
                                disabled={!firstName.trim() || !lastName.trim() || saving} onClick={saveProfile}>
                        <Translate text="save"/>
                    </BlueButton>
                </React.Fragment>
            }
        >
            <div className="settings-modal-fields" style={{minWidth: '420px'}}>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <FileUpload
                        windowSize={96}
                        imgSize={88}
                        progressSize={96}
                        svgSize={28}
                        image={thumbUrl}
                        handleChange={setThumbUrl}
                        handleDelete={() => setThumbUrl('')}
                    />
                </div>
                <Input
                    label={<Translate text="firstName"/>}
                    value={firstName}
                    maxLength={50}
                    style={{height: '40px'}}
                    onChange={event => setFirstName(event.target.value)}
                />
                <Input
                    label={<Translate text="lastName"/>}
                    value={lastName}
                    maxLength={50}
                    style={{height: '40px'}}
                    onChange={event => setLastName(event.target.value)}
                    onKeyDown={event => {
                        if (event.key === 'Enter') saveProfile();
                    }}
                />
            </div>
        </Modal>
    );
};

EmployeeProfileModal.propTypes = {
    member: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export default EmployeeProfileModal;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeeProfileModal.jsx